export default __webpack_public_path__ + "static/media/06- TAMIRES.eab11c7e.gif";